import { defineComponent, h, useAttrs } from 'vue'
import {
  VDatePicker,
  VDatePickerMonth,
  VDatePickerMonths,
  VDatePickerYears
} from 'vuetify/components'
import { hasBooleanishAttr } from './legacyInputProps'

VDatePicker.compatConfig = {
  ...(VDatePicker.compatConfig || {}),
  COMPONENT_V_MODEL: false
}

VDatePickerMonth.compatConfig = {
  ...(VDatePickerMonth.compatConfig || {}),
  COMPONENT_V_MODEL: false
}

VDatePickerMonths.compatConfig = {
  ...(VDatePickerMonths.compatConfig || {}),
  COMPONENT_V_MODEL: false
}

VDatePickerYears.compatConfig = {
  ...(VDatePickerYears.compatConfig || {}),
  COMPONENT_V_MODEL: false
}

function normalizeDateValue(value) {
  if (value == null || value === '') return value
  if (Array.isArray(value)) return value.map(normalizeDateValue)
  if (typeof value === 'string') return value

  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    const year = value.getFullYear()
    const month = String(value.getMonth() + 1).padStart(2, '0')
    const day = String(value.getDate()).padStart(2, '0')
    return `${year}-${month}-${day}`
  }

  return value
}

function normalizeAttrs(attrs) {
  const normalized = { ...attrs }

  normalized.modelValue = attrs.modelValue ?? attrs.value

  if (hasBooleanishAttr(attrs.range) && normalized.multiple == null) {
    normalized.multiple = 'range'
  }

  if (hasBooleanishAttr(attrs['no-title']) && normalized.hideTitle == null) {
    normalized.hideTitle = true
  }

  if (attrs['show-current'] === false || attrs.showCurrent === false) {
    normalized.hideHeader = true
  }

  delete normalized.value
  delete normalized.range
  delete normalized['no-title']
  delete normalized.noTitle
  delete normalized.scrollable
  delete normalized.reactive
  delete normalized['show-current']
  delete normalized.showCurrent

  return normalized
}

export default defineComponent({
  name: 'VDatePickerCompat',
  compatConfig: {
    RENDER_FUNCTION: false,
    COMPONENT_V_MODEL: false,
    INSTANCE_ATTRS_CLASS_STYLE: false
  },
  inheritAttrs: false,
  emits: ['update:modelValue', 'input', 'change'],

  setup(_, { emit, slots }) {
    const attrs = useAttrs()

    const emitLegacyValue = (value) => {
      const normalizedValue = normalizeDateValue(value)
      emit('update:modelValue', normalizedValue)
      emit('input', normalizedValue)
      emit('change', normalizedValue)
    }

    return () => {
      const normalizedAttrs = normalizeAttrs(attrs)
      delete normalizedAttrs.onInput
      delete normalizedAttrs.onChange
      delete normalizedAttrs['onUpdate:modelValue']

      return h(
        VDatePicker,
        {
          ...normalizedAttrs,
          'onUpdate:modelValue': emitLegacyValue
        },
        {
          ...slots,
          actions: slots.actions || slots.default
        }
      )
    }
  }
})
